import React from 'react';
import { Route ,Routes} from 'react-router-dom';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import routes from '../../routes';
import Link from '@material-ui/core/Link';
import { Typography } from '@material-ui/core';
//import { BreadCrumb } from 'primereact/breadcrumb';
import { Link as RouterLink } from 'react-router-dom';
const findRouteName = (url) => routes[url];

// const getPaths = (pathname) => {
// 	const paths = [];
// 	/*if (pathname === '/dashboard'){
//            const paths = ['/'];
//            return paths;
//   }else if(pathname === '/dashboard/createuser' || pathname === '/dashboard/edituser'){
//            paths.push("/");
//   }else{
//            const paths = [];
//   } */

// 	pathname.split('/').reduce((prev, curr) => {
// 		const currPath = `${prev}/${curr}`;
// 		paths.push(currPath);
// 		return currPath;
// 	});
// 	return paths;
// };

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;
export default (props) => (
	<div>
		<Routes path="/:path" {...props}>
			<Route>
				{({ location }) => {
					const pathnames = location.pathname.split('/').filter((x) => x);

					return (
						<Breadcrumbs aria-label="breadcrumb">
							{/* <LinkRouter color="inherit" to="/">
								Home
							</LinkRouter> */}
							{pathnames.map((value, index) => {
								const last = index === pathnames.length - 1;
								const to = `/${pathnames.slice(0, index + 1).join('/')}`;

								return last ? (
									<Typography color="textPrimary" key={to}>
										{findRouteName(to)}
									</Typography>
								) : (
									<LinkRouter color="inherit" to={to} key={to}>
										{findRouteName(to)}
									</LinkRouter>
								);
							})}
						</Breadcrumbs>
					);
				}}
			</Route>
		</Routes>
	</div>
);

// const BreadcrumbsItem = ({ match }) => {
// 	const routeName = findRouteName(match.url);
// 	/* const logedinuserrole = util.getData("userDetails").appRoleClientCompanies[0].role.name;*/
// 	if (routeName) {
// 		return match.isExact ? (
// 			<BreadcrumbItem active>{routeName}</BreadcrumbItem>
// 		) : (
// 			<BreadcrumbItem>
// 				<Link to={match.url} className="home_color">
// 					{match.url === '/' && <i className="fa fa-home"></i>}
// 					{routeName}
// 				</Link>
// 			</BreadcrumbItem>
// 		);
// 	}
// 	return null;
// };

// const Breadcrumbs = ({ location: { pathname } }) => {
// 	const paths = getPaths(pathname);
// 	const items = paths.map((path, i) => (
// 		<Route key={i++} path={path} component={BreadcrumbsItem} />
// 	));

// 	return <Breadcrumb className="m-0">{items}</Breadcrumb>;
// };

// export default (props) => (
// 	<div>
// 		<Route path="/:path" component={Breadcrumbs} {...props} />
// 	</div>
// );
